module.exports = __webpack_public_path__ + "img/default-browse-vehicles-chevy.3abaa0c3.png";